export enum ProgramSort {
  none = 0,
  programName = 1,
  programType = 2,
  educationSector = 3
}